import { useContext } from 'react';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import AccessControl from 'Global/security/AccessControl';
import { useLocation } from 'react-router-dom';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import { hwndjs } from 'utils/hwnd';

export const visitOperations = (Patient) => {
  const disableActions = false;

  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop
  const languageArray =
    useContext(GlobalContext)?.LanguageArray;
  const { pathname } = useLocation();

  const cachedIcons = JSON.parse(
    localStorage.getItem('icons')
  );
  const imgHeader = 'data:image/svg+xml;base64,';

  const DataArray = [
    {
      ...(disableActions
        ? {}
        : {
            title: FindLangKey(
              'current-patients-patient-actions-medical-form',
              languageArray
            ),
            image:
              imgHeader +
              cachedIcons?.MenueIcon[
                'Medicalrecord.svg'
              ],
            path:
              screenWidth > 1024
                ? '/main/AddNewElectronicForm'
                : '/AddNewElectronicForm',
            disabled: AccessControl(
              pathname.toLowerCase() ===
                '/CurrentPatients'.toLowerCase()
                ? 'current-patient-action-medical-form'
                : 'patient-list-action-medical-form'
            ),
          }),
    },
    // {
    //   title: FindLangKey(
    //     'main-menu-button-pacs-images',
    //     languageArray
    //   ),
    //   image:
    //     imgHeader +
    //     cachedIcons?.GeneralIcon['ViewServices.svg'],
    //   path: `/pacsImages?${hwndjs(Patient?.FldId)}`,
    //   disabled: false,
    // },
    {
      ...(disableActions
        ? {}
        : {
            title: FindLangKey(
              'general-public-add-new-confer',
              languageArray
            ),
            image:
              imgHeader +
              cachedIcons?.MenueIcon[
                'Serviceregistration.svg'
              ],
            path:
              screenWidth > 1024
                ? '/main/AddNewConfer'
                : '/AddNewConfer',
            func: sessionStorage.removeItem(
              'savedServices'
            ),
            disabled: AccessControl(
              pathname.toLowerCase() ===
                '/CurrentPatients'.toLowerCase()
                ? 'current-patient-action-set-confer'
                : 'patient-list-action-set-confer'
            ),
          }),
    },
    {
      title: FindLangKey(
        'current-patients-patient-actions-list-service-confer',
        languageArray
      ),
      image:
        imgHeader +
        cachedIcons?.MenueIcon['Viewservices.svg'],
      path:
        screenWidth > 1024
          ? '/main/ListServiceConfer'
          : '/ListServiceConfer',
      disabled: AccessControl(
        pathname.toLowerCase() ===
          '/CurrentPatients'.toLowerCase()
          ? 'current-patient-action-list-service-confer'
          : 'patient-list-action-list-service-confer'
      ),
    },
  ];

  return DataArray;
};
